import { useLazyQuery } from '@apollo/client';
import { GET_CONFIGURATION } from 'graph_ql/configuration/queries.gql';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getConfiguration } from '__generated__/getConfiguration';
import { useConfiguration } from '.';
import { setConfiguration } from './slice';
import { SESSION_STORAGE_KEY } from 'utils/constant';
import { TimedSessionStorage } from 'utils/TimedSessionStorage';
import { useQueryParams } from '../../hooks/useQueryParams';
import { DYNAMIC_LAYOUT_PARAM } from '../../constants';

export const ConfigurationProvider = (props) => {
    const queryParams = useQueryParams();
    const dynamicLayoutVersion = queryParams.get(DYNAMIC_LAYOUT_PARAM);
    const { children } = props;
    const dispatch = useDispatch();
    useConfiguration();
    const [getConfiguration] = useLazyQuery<getConfiguration, any>(GET_CONFIGURATION, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            let configuration: any = data?.getConfiguration;
            const store = TimedSessionStorage.getItemWithExpiration(SESSION_STORAGE_KEY.TAFFI_STORE_DETAILS);
            if (dynamicLayoutVersion) {
                configuration = {
                    ...configuration,
                    stitcher: {
                        ...configuration?.stitcher,
                        dynamicLayoutVersion,
                    },
                };
            } else if (store && store.styleLayoutVersion) {
                configuration = {
                    ...data?.getConfiguration,
                    stitcher: {
                        ...data?.getConfiguration?.stitcher,
                        dynamicLayoutVersion: store.styleLayoutVersion,
                    },
                };
            }
            TimedSessionStorage.setItemWithExpiration(SESSION_STORAGE_KEY.TAFFI_CONFIGURATION, configuration);
            dispatch(setConfiguration(configuration));
        },
    });
    useEffect(() => {
        try {
            const configuration = TimedSessionStorage.getItemWithExpiration(SESSION_STORAGE_KEY.TAFFI_CONFIGURATION);
            if (configuration) {
                dispatch(
                    setConfiguration({
                        ...configuration,
                        ...(dynamicLayoutVersion
                            ? {
                                stitcher: {
                                    ...configuration?.stitcher,
                                    dynamicLayoutVersion,
                                },
                            }
                            : {}),
                    }),
                );
            } else getConfiguration().then(() => {});
        } catch (error) {
            if (error instanceof SyntaxError) {
                console.error('Invalid JSON:', error);
            } else console.log('Error Occured: ', error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <>{children}</>;
};
